import InmuebleDocsList from "../InmuebleDocsList";

const ArchivosRentaTable = ({ data, refetch }) => {
    let datosFacturacion = data?.datos_facturacion;

    if (typeof datosFacturacion === "string") {
        try {
            datosFacturacion = JSON.parse(datosFacturacion);
        } catch (error) {
            console.error("Error al parsear datos_facturacion:", error);
            datosFacturacion = {};
        }
    };

    return (
        <>
            <div className="w-full">
                <InmuebleDocsList data={data} refetch={refetch} />
            </div>
        </>
    );
};

export default ArchivosRentaTable;
